import styled from '@emotion/styled'
import { spacer } from 'stylist'

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: ${spacer(5)};
`
export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js